module.exports = __webpack_public_path__ + "img/p3.23c4a4a5.png";